import { useEffect, useRef } from "react";

/**
 * Custom hook to scroll the window to the top (0, 0) when a specified dependency changes,
 * skipping the initial component mount.
 * @param {any | any[]} dependency The dependency or array of dependencies to watch for changes.
 */
export function useScrollToTopOnChange(...dependencies) {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
